import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import EASelect from "../../shared/EASelect/EASelect";
import { State } from "../../../store";
import { useLinkedAccountsOptions, MY_ACCOUNT_ACCOUNT_FILTER_ALL } from "../../../../utils/hooks/useLinkedAccountsOptions";
import { parseAccountIdsFromSearch, setAccountIdsInSearch } from "../../../../utils/myAccountTabUrl";

const MyAccountAccountFilter: React.FC = () => {
  const allowSubaccounts = useSelector((s: State) => s.config.configuration.allowSubaccounts === true);
  const { options, loading } = useLinkedAccountsOptions();
  const location = useLocation();
  const navigate = useNavigate();

  if (!allowSubaccounts) {
    return null;
  }

  const raw = parseAccountIdsFromSearch(location.search);
  const value = raw ?? MY_ACCOUNT_ACCOUNT_FILTER_ALL;

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const next = e.target.value;
    const qs = setAccountIdsInSearch(
      location.search,
      next === MY_ACCOUNT_ACCOUNT_FILTER_ALL ? "" : next
    );
    navigate(`${location.pathname}?${qs}`, { replace: true });
  };

  return (
    <div>
      <EASelect
        label="Osoba"
        name="myAccountAccountIds"
        value={value}
        onChange={handleChange}
        options={options}
        disabled={loading}
      />
    </div>
  );
};

export default MyAccountAccountFilter;
